import type { SymbolDefinition } from "../types.ts";

export const fuse: SymbolDefinition = {
  id: "ep-fuse",
  familyKey: "fuse",
  deviceKind: "fuse",
  version: "0.1.0",
  label: { sv: "Säkring", en: "Fuse" },
  description: { sv: "Smältsäkring.", en: "Fuse." },
  viewBox: "0 0 24 24",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <rect x="9" y="6" width="6" height="12" rx="1"/>
      <line x1="12" y1="2" x2="12" y2="6"/>
      <line x1="12" y1="18" x2="12" y2="22"/>
    </g>
  `,
  terminals: [
    { id: "in", kind: "phase", label: "L", position: "top", offset: 0.5 },
    { id: "out", kind: "phase", label: "T", position: "bottom", offset: 0.5 },
  ],
  designationPrefix: "F",
  searchKeywords: ["säkring", "smältsäkring", "fuse"],
};
